export default __webpack_public_path__ + "static/media/Bracers of Dark Malice.f89d3dc2.jpg";